import { Box, Button, Title, Text, Center } from '@mantine/core';
import { IconBrandGoogle } from '@tabler/icons-react';
import { buildFullUrl } from '../utils/urlUtils';

export default function Login() {
  const handleGoogleLogin = () => {
    // Don't include 'api' in path, it's already in VITE_API_URL
    const url = buildFullUrl('auth/google');
    console.log('OAuth Debug:', {
      url,
      apiBase: import.meta.env.VITE_API_URL,
      expectedCallback: 'https://api.betfol.io/api/auth/google/callback'
    });
    window.location.href = url;
  };

  return (
    <Center style={{ height: 'calc(100vh - 60px)' }}>
      <Box style={{ maxWidth: 400, width: '100%', padding: '2rem' }}>
        <Title align="center" mb="xl">Welcome to Betfolio</Title>
        
        <Text align="center" mb="xl" color="dimmed">
          Track and manage your sports betting activity with ease
        </Text>

        <Button
          fullWidth
          leftIcon={<IconBrandGoogle size={20} />}
          onClick={handleGoogleLogin}
          variant="outline"
          mb="md"
        >
          Continue with Google
        </Button>

        <Text align="center" size="sm" color="dimmed">
          By continuing, you agree to our Terms of Service and Privacy Policy
        </Text>
      </Box>
    </Center>
  );
}